import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { profile: true },
  path: '/teams/:team_uuid/accept-invite/:token',
  component: () => import('@/views/accept-team-invite.vue'),
} satisfies RouteRecordRaw;
